/*
 * 詳細画面パーツ
 * 日時入力
 */
<template>
<tr class="tr-td-control">
	<td v-if="r_disp_title" class="td-dataname text_code_area">
		<div><!--
			-->{{r_title}}
			<div v-if="r_settings.edit_right && r_is_require" class="layout-right">
				<font class="text-red">＊</font>
			</div>
		</div>
	</td>
	<td v-if="r_settings.edit_right" :class="td_data_class">
		<el-form :model="m_ruleForm" :rules="m_validationCode" ref="valid_target">
			<el-form-item prop="date" >
				<c-input-date-picker 
					v-model="m_ruleForm.date"
					:r_messages="r_messages"
					:r_settings="r_settings"
					@input="onInput"
					:r_class="createEditClassType(m_ruleForm.date)"
					:r_clearable="r_clearable"
					:r_picker_option_type="r_picker_option_type"
					:r_picker_option_disabled="r_picker_option_disabled"
					:r_date_disp_cl="r_date_disp_cl"
					:r_readonly="r_readonly"
					@focus="onFocus"
					@blur="onBlur"
				>
				</c-input-date-picker>
			</el-form-item>
			<slot name="text_footer"></slot>
			<div v-if="r_ext_message" class="ext_message">
				{{r_ext_message}}
			</div>
		</el-form >
	</td>
	<td  v-if="!r_settings.edit_right" class="td-data">
		{{m_ruleForm.date}}
		<slot name="text_footer"></slot>
	</td>
</tr>
</template>
<script>
	/**
	 * 詳細画面パーツ.<br>
	 * メモ.<br>
	 * @module js\parts\DetailItemName
	 * @example
	 * <c-detailitemname
	 * 	:messages = "messages" 
	 * 	:settings = "settings" 
	 * 	:info="m_info" 
	 * 	@keyup="keyup" 
	 * >
	 * </c-detailitemname>
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_title - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {object} value - 編集するデータ
	 **/
	 export default {
		mixins: [
			require('js/common/Edit2.mixin.vue'),
			require('js/common/trEdit.mixin.vue'),
			// バリデーションミックスイン
			require('js/common/validate/common.mixin.vue'),
			require('js/common/validate/edit.mixin.vue'),
		],
		props:{
			'r_disp_title':{
				type:Boolean,
				default:true
			},//!< r_disp_titleタイトル<td>を非表示にしたい場合はfalseにする。
			'r_title': String,
			'r_settings': {},
			'r_messages':{},
			'value': "",
			'r_validator':null,//!< validate 処理を変更したい場合に指定する。指定がなければデフォルトチェックが有効になる
			'r_is_def_validator':{
				type:Boolean,
				default:false
			},//!< r_validator変更したバリデーションと既存バリデーションを行いたい場合はtrueにする。
			// その他のメッセージ
			'r_ext_message': String,
			// 日付のクリアボタンがあるか
			'r_clearable':{
				type:Boolean,
				default: false
			},
			// カレンダーの選択肢
			'r_picker_options': {},
			'r_picker_option_type':{
				type:Number,
				default: 1
			},
			'r_picker_option_disabled':{
				type:String,
				default: '',
			},
			'r_readonly': {
				type:Boolean,
				default: false
			},
			'r_date_disp_cl': {
				type: Number,
				default: 0,
			},
		},
		data: function (){
			var target = this;
			return{
				m_ruleForm: {date:this.value},
				m_validationCode:{
					// date: [
					// 	{ required: this.r_is_require, message: this.r_messages.required,trigger:'no' },
					// 	{
					// 		validator: (rule, value, callback) => {
					// 			var errMessage = "";
					// 			var fnValidate = (target.r_validator)?target.r_validator:target.validateType;
					// 			var type = target.CHKTYPE_DATE;

					// 			if (this.r_is_def_validator){
					// 				errMessage = target.validateType(type, value);
					// 			}
					// 			errMessage += fnValidate(type, value);

					// 			if ( errMessage.length > 0 ) {
					// 				callback(new Error(errMessage));
					// 			} else {
					// 				callback();
					// 			}

					// 		},
					// 		trigger: ''
					// 	}
					// ],
				},
			}
		},
		/**
		 * @instance
		 **/
		computed: {
			td_data_class:function(){
				return this.r_disp_title ? 'td-data' : 'td-data-inner';
			},
		},
		watch:{
			value: function(val){
				this.m_ruleForm.date = val;
			}
		},
		methods: {
			/**
			 * キーアップイベント <br>
			 * ******* 内部処理 *******<br>
			 * フラグを変更する。 <br>
			 *
			 * @function onKeyup
			 * @param {object} e - イベントオブジェクト
			 * @instance
			 */
			onKeyup: function( e ){
			 	this.$emit('keyup', e);
			},
			onInput: function(date) {
				this.m_isChange = true;
				this.$emit("input",date);
			},
			onFocus: function(e) {
				this.$emit('focus', e);
			},
			onBlur: function(e) {
				this.$emit('blur', e);
			},
		},
		/**
		 * ファイル内で使用しているコンポーネント <br>
		 * cはグローバルコンポーネント(宣言は親のjsファイルで行っている)<br>
		 * @prop {component} c-inputname - 文字入力
		 * @instance
		 **/
		components: {
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/TR/editDatePicker.vue